export default __webpack_public_path__ + "static/media/trevor-j-alt-cerulean.2ee380a8.png";